export default class PathResolutionError extends Error {}
